import { render, staticRenderFns } from "./admin-secrets.vue?vue&type=template&id=79cad95c&scoped=true&"
import script from "./admin-secrets.vue?vue&type=script&lang=js&"
export * from "./admin-secrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cad95c",
  null
  
)

export default component.exports